class InteractiveShowcase {
  constructor(element) {
    this.showcase = element;
    this.products = Array.from(element.querySelectorAll('.product-item'));
    this.navDots = Array.from(element.querySelectorAll('.nav-dot'));
    
    this.autoRotateEnabled = element.dataset.autoRotate === 'true';
    this.rotationSpeed = parseFloat(element.dataset.rotationSpeed) * 1000;
    
    this.currentIndex = 0;
    this.autoRotationInterval = null;
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.showProduct(0);
    this.startAutoRotation();
  }

  bindEvents() {
    // Navigation
    this.navDots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.handleNavClick(index));
    });

    // Intersection Observer for pausing animations when not visible
    const observer = new IntersectionObserver(
      (entries) => this.handleVisibilityChange(entries[0]),
      { threshold: 0.2 }
    );
    observer.observe(this.showcase);
  }

  handleVisibilityChange(entry) {
    if (entry.isIntersecting) {
      this.startAutoRotation();
    } else {
      this.stopAutoRotation();
    }
  }

  handleNavClick(index) {
    this.showProduct(index);
    this.startAutoRotation();
  }

  showProduct(index) {
    this.products.forEach((product, i) => {
      product.classList.toggle('active', i === index);
      this.navDots[i].classList.toggle('active', i === index);
      this.navDots[i].setAttribute('aria-selected', i === index);
    });
    this.currentIndex = index;
  }

  nextProduct() {
    const nextIndex = (this.currentIndex + 1) % this.products.length;
    this.showProduct(nextIndex);
  }

  startAutoRotation() {
    if (!this.autoRotateEnabled) return;
    this.stopAutoRotation();
    this.autoRotationInterval = setInterval(() => this.nextProduct(), this.rotationSpeed);
  }

  stopAutoRotation() {
    if (this.autoRotationInterval) {
      clearInterval(this.autoRotationInterval);
      this.autoRotationInterval = null;
    }
  }
}

// Initialize all showcases on the page
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.interactive-showcase').forEach(showcase => {
    new InteractiveShowcase(showcase);
  });
});